const baseColors = {
  textColor: "#ffffff",
  primaryColor: "#7d52f3",
  backgroundColor: "#17181f",
  foregroundColor: "#23242a",
  errorColor: "#ff4444",
  successColor: "#44ff44",
};

const buildDefault = (
  colors: Record<string, string>,
  template: string,
  extras: Record<string, unknown> = {}
) => ({
  layout: JSON.stringify({ ...colors, template }),
  banner: JSON.stringify([]),
  background: JSON.stringify([]),
  ...extras,
});

export const LOBBY_CONFIG_DEFAULTS: Record<string, Record<string, unknown>> = {
  "lobby/config": buildDefault(
    { ...baseColors, progressColor: "#ed5f00", lobbyButtonColor: "#7d52f3" },
    "f2p",
    { hasHowToPlay: false, howToPlay: [] }
  ),
  "lobby/config/casino": buildDefault({ ...baseColors, missionBannerColor: "#1ba43d" }, "f2p", {
    lobbyVisibility: JSON.stringify({ badges: false, ranks: false }),
  }),
  "lobby/config/mission": buildDefault(
    {
      ...baseColors,
      expiredColor: "#2C243C",
      missionFilterColor: "#dc00ff",
      missionFilterTextColor: "#ffffff",
    },
    "mission"
  ),
  "lobby/config/shop": buildDefault(
    { ...baseColors, cardColor: "#23242a", errorColor: "#f70628", successColor: "#00a83c" },
    "shop"
  ),
  "lobby/config/badge": buildDefault(baseColors, "badges"),
  "lobby/config/rank": buildDefault(baseColors, "ranks"),
};
